import { OrderCategory, TApiOrderDetails } from "../../../../api/endpoints/Order";
import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { formatDecimal, formatMegaBytes, withDefault } from "../../../../utils/Format";
import * as React from "react";
import { totalEpu } from "../../../../utils/Cost";
import ProductDetails from "./ProductDetails";
import { TApiSet } from "../../../../api/endpoints/Set";
import { deriveBcType, deriveDataSetName } from "../../../../utils/DataSet";
import { Fragment } from "react";
import { TApiParameter } from "../../../../api/endpoints/Parameter";
import { TOrderProduct } from "../../../../api/endpoints/OrderProduct";

interface IProps {
  order: TApiOrderDetails<OrderCategory.REALTIME>;
  products: Array<TOrderProduct<OrderCategory.REALTIME>>;
  sets: Array<TApiSet>;
  params: {
    [shortname: string]: TApiParameter
  };
  epuFootnoteRef?: string;
}

const grey = "#f0f0f0";
const paddingXs = "2mm";
const paddingSm = "3mm";
const fontItalic = "Helvetica-Oblique";

const styles = StyleSheet.create({
  itemRow: {
    paddingBottom: paddingXs
  },
  title: {
    fontFamily: fontItalic
  },
  colLeft: {
    width: "30%"
  },
  colRight: {
    width: "70%",
    paddingLeft: paddingXs
  },
  flexRow: {
    flexDirection: "row"
  },
  flexWrap: {
    flexWrap: "wrap"
  },
  productName: {
    paddingBottom: paddingXs
  },
  productWrap: {
    flexDirection: "column"
  },
  infoLeft: {
    width: "70%",
    padding: paddingSm,
    borderRight: `1pt solid ${grey}`
  },
  infoRight: {
    width: "30%",
    padding: paddingSm
  },
  nameHeader: {
    width: "70%",
    borderRight: "1pt solid white",
    padding: paddingSm
  },
  costHeader: {
    width: "30%",
    paddingLeft: paddingSm
  },
  productHeader: {
    backgroundColor: grey,
    alignItems: "center"
  },
  productSummary: {
    backgroundColor: grey,
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'right',
    alignItems: 'center'
  },
  productSummaryColumn: {
    padding: paddingSm
  }
});

const RealtimeOrderPdfDetails = (props: IProps) => {
  const { order, sets, params, products } = props;

  return (
    <View>
      {
        products.map((product, index) => {
          const dataSetName = deriveDataSetName(product.data, sets);
          const bcType = deriveBcType(product.data, sets);

          return <ProductDetails
            params={params}
            dataSetName={dataSetName}
            key={product.id}
            product={product}
            bcType={bcType}
            timestamp={order.updated}
            cost={order.cost.data.per_product && order.cost.data.per_product[index]}
          />;
        })
      }

      {
        products.length <= 0 &&
        <Text>You have no products in your order.</Text>
      }

      {
        order.cost.version === 'v1' && order.cost.data.total_cost &&
        <Fragment>
          <View style={styles.productSummary}>
            <View style={[styles.productSummaryColumn, { width: '70%' }]}>
              <Text>Total daily volume</Text>
            </View>
            <View style={[styles.productSummaryColumn, { width: '30%' }]}>
              <Text>
                {
                  withDefault(
                    order.cost.data.total_cost.average_daily_volume ? (order.cost.data.total_cost.average_daily_volume * 0.000001) : undefined,
                    formatMegaBytes,
                    "--"
                  )
                }
              </Text>
            </View>
          </View>
        </Fragment>
      }
    </View>
  )
}

export default RealtimeOrderPdfDetails;
